import * as React from 'react';
import iconAlert from '../../../assets/icons/icon-alert.svg';
import iconSuccess from '../../../assets/icons/icon-success.svg';
import iconInfo from '../../../assets/icons/icon-info.svg';

class Message extends React.Component {

  static Types = {
    ERROR: 'error',
    SUCCESS: 'success',
    INFO: 'info',
  };

  render() {
    const { type, message, showMessage = true, className } = this.props;

    let icon = iconAlert;
    switch (type) {
      case Message.Types.ERROR: icon = iconAlert; break;
      case Message.Types.SUCCESS: icon = iconSuccess; break;
      case Message.Types.INFO: icon = iconInfo; break;
      default: icon = iconAlert;
    }

    if (showMessage && message && message.length > 0) {
      return (
        <div className={className}>
          <div className="Message-container">
            <img className="Message-img" alt="" src={icon} />
            <div className="Message-text">
              {Array.isArray(message) ? 
                message.map((msg,index) => <span key={index}>{msg}</span>) :
                message
              }
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default Message;
